<template>
  <div class="StudyListViewContainer">
    <div class="blueBgNotice pd16" style="padding-bottom: 0">
      <nut-row class="bothCenter">
        <nut-col :span="21" class="leftCenter">
          <div class="searchInput leftCenter">
            <img src="../../assets/image/search.png" />
            <input type="text" placeholder="请输入名称..." v-model="nameLike" @change="onNameLickChange">
          </div>
        </nut-col>
        <nut-col :span="3" class="filterBtn colFlex bothCenter" @click="filterVisible=true">
          <img src="../../assets/image/filter_icon.png"/>
        </nut-col>
      </nut-row>
      <div class="type_box">
        <div class="left" @click="changeType('0')">
          视频
        </div>
        <div class="right" @click="changeType('1')">
          图片
        </div>
      </div>
      <div class="select_box">
        <div :class="mediaType=='0'?'box_item':'box_item1'" v-for="(item,index) in options" :key="index" @click="onFilterConfirm(item)">{{ item.topic }}</div>
      </div>
    </div>
    <template v-if="mediaType==0">
      <InfiniteLoadingList :query-id="1" :init-query="initQuery1" style="display: flex;">
        <template v-slot="data">
          <StudyItem :data="data.data" @click="preview(data.data)"/>
        </template>
      </InfiniteLoadingList>
    </template>
    <template v-else-if="mediaType==1">
      <InfiniteLoadingList :query-id="1" :init-query="initQuery2">
        <template v-slot="data">
          <StudyItem :data="data.data" @click="preview(data.data)"/>
        </template>
      </InfiniteLoadingList>
    </template>
  </div>

  <div class="bottomBtns" v-if="repoExist">
    <nut-button class="questionTest" @click="$router.push('/study/repo/detail')">答题测试</nut-button>
  </div>
  <nut-popup position="bottom"
             round
             :close-on-click-overlay="true"
             v-model:visible="filterVisible">
    <nut-row>
      <StudyFilter @confirm="onFilterConfirm"/>
    </nut-row>
  </nut-popup>
  <nut-overlay
      class="bothCenter"
      @close="playerVisible=false"
      :close-on-click-overlay="false"
      v-model:visible="playerVisible">
    <div class="colFlex bothCenter">
      <video v-if="playerVisible" :src="videoUrl" controls style="width: 100%" @ended="onPlayEnd"/>
      <div class="whiteFont smallFont bothCenter vmg16" @click="playerVisible=false">
        <nut-icon name="close" size="12"></nut-icon>
        <span>关闭视频</span>
      </div>
    </div>
  </nut-overlay> 
</template>

<script>
import StudyItem from "@/components/study/StudyItem";
import StudyFilter from "@/components/study/StudyFilter";
import InfiniteLoadingList from "@/components/InfiniteLoadingListStudy";
import api from "@/api";

export default {
  name: "StudyListView",
  components: {InfiniteLoadingList,StudyFilter, StudyItem},
  data() {
    return {
      repoExist: false,
      filterVisible: false,
      playerVisible: false,
      nameLike: null,
      videoUrl: null,
      categoryTypeId: null,
      initQuery1: {
        dataType: 1,
      },
      initQuery2: {
        dataType: 0,
      },
      mediaType: '0',
      options:[]
    }
  },
  methods: {
    changeType(i){
      this.mediaType = i
    },
    onNameLickChange() {
      this.initQuery1 = {
        categoryTypeId: this.categoryTypeId,
        name: this.nameLike,
        dataType: 1,
      }
      this.initQuery2 = {
        categoryTypeId: this.categoryTypeId,
        name: this.nameLike,
        dataType: 0,
      }
    },
    onFilterConfirm(f) {
      this.$store.commit('setStudyFilter', {
        selected: f.id,
      })
      this.filterVisible = false;
      this.categoryTypeId = f.id;
      this.initQuery1 = {
        categoryTypeId: this.categoryTypeId,
        name: this.nameLike,
        dataType: 1,
      }
      this.initQuery2 = {
        categoryTypeId: this.categoryTypeId,
        name: this.nameLike,
        dataType: 0,
      }
    },
    onPlayEnd() {
    },
    preview(data) {
      api.markStudyView(data.id);
      if (data.dataUrl.endsWith('mp4')) {
        this.videoUrl = data.dataUrl;
        this.playerVisible = true;
      }
    },
    init() {
      api.getActivedRepo()
          .then(ret => {
            if (ret) {
              this.repoExist = true;
            }
          })
      api.getStudyDataFilter()
      .then(ret => {
        this.options = ret.filter((i) => i.id!=0);
      })
    },
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.bottomBtns {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  background-color: white;
  padding: 10px 0;

  .questionTest {
    width: 80%;
    height: 44px;
    color: white;
    background: #2F438C;
    border-radius: 12px;
    border: none;
  }
}

.StudyListViewContainer {
  display: flex;
  flex-direction: column;
  background-color: #F4F6F9;
  // padding: 8px 16px;
  min-height: 100vh;
  padding-bottom: 100px;

  .searchInput {
    margin-top: 4px;
    width: 90%;
    border-radius: 20px;
    background-color: white;
    display: flex;
    padding: 6px 10px;

    input {
      border: none;
      margin-left: 8px;
      width: 80%;
      font-size: $smallerFontSize;
    }

    input::placeholder {
      font-size: $smallerFontSize;
    }

    input:focus {
      outline: none;
    }
    img{
      width: 15px;
      height: 15px;
    }
  }

  .filterBtn {
    img {
      height: 20px;
      width: 20px;
    }

    span {
      font-size: $minFontSize;
    }
  }
  .blueBgNotice {
    display: flex;
    flex-direction: column;
    height: 150px;
    background: #2F438C;
    border-radius: 0px 0px 24px 24px;
    margin-bottom: 15px;
    .type_box{
      display: flex;
      width: 100%;
      justify-content: space-between;
      color: #fff;
      text-align: center;
      margin: 20px 0;
      font-size: $smallerFontSize;
      .left{
        background-image: url('../../assets/image/type_bg.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        width: 48.5%;
        height: 28px;
        line-height: 28px;
      }
      .right{
        background-image: url('../../assets/image/type1_bg.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        width: 48.5%;
        height: 28px;
        line-height: 28px;
      }
    }
    .select_box{
      display: flex;
      width: 100%;
      justify-content: space-between;
      color: #fff;
      text-align: center;
      font-size: $smallerFontSize;
      .box_item{
        background-image: url('../../assets/image/type_sbg.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        width: 23%;
        height: 26px;
        line-height: 26px;
      }
      .box_item1{
        background-image: url('../../assets/image/type1_sbg.png');
        background-size: 100% 100%;
        background-repeat: no-repeat;
        width: 23%;
        height: 26px;
        line-height: 26px;
      }
    }
  }
}
</style>